import { BActionIcon } from '@components/BActionIcon/BActionIcon';
import { Anchor, Group, Stack, Title } from '@mantine/core';
import React from 'react';
import { Button, helpMenuStack } from './HelpMenu.styles';
import { HelpMenuSection } from './HelpMenuSection';

interface HelpMenuProps extends React.RefAttributes<HTMLDivElement> {
  close: VoidFunction;
}

export function HelpMenu(props: HelpMenuProps) {
  const { close } = props;
  return (
    <Stack mb={16} sx={helpMenuStack} className="new-icon">
      <Group position="apart">
        <Title order={4}>Help &amp; Resources</Title>
        <BActionIcon icon="cross" onClick={close} />
      </Group>
      <HelpMenuSection
        icon="learning"
        title="Find Resources"
        paragraph={
          <>
            Check out our{' '}
            <Anchor
              href="https://resources.beamdynamics.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Resource Center
            </Anchor>{' '}
            for user manuals, articles, and case studies to help you on your
            way.
          </>
        }
      />
      <Button
        href="https://forms.clickup.com/31162583/f/xq06q-2303/9PXI0OYSOK1TG56P7X"
        target="_blank"
      >
        <HelpMenuSection
          icon="lifesaver"
          title="Share Issue, Feedback or Feature Requests"
          paragraph={<>Can something be improved? We want to know!</>}
        />
      </Button>
    </Stack>
  );
}
